import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder,FormGroup, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { AveriasService } from '../servicios/averias.service';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import { Column, GridOption, AngularGridInstance, FileType, } from 'angular-slickgrid';
import { PerfilesUsuarioService } from '../servicios/perfiles-usuario.service';
import { DatePipe } from '@angular/common';
import { codificacionModelosDTO, modeloDTO } from '../entidades/entidades.component';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NbDialogService } from '@nebular/theme';
import { PopupConfirmacionComponent } from './popup-confirmacion/popup-confirmacion.component';

//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule  } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';

import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import type { ColDef } from 'ag-grid-community'; // Column Definition Type Interface
import { GridApi, GridReadyEvent } from 'ag-grid-community';

import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

@Component({
    selector: 'app-modelos',
    templateUrl: './modelos.component.html',
    styleUrls: ['./modelos.component.css'],
    standalone: true,
    imports: [FormsModule, MatIconModule, CommonModule, NbCardModule, NbIconModule, DropdownModule, 
      MatCardModule, MatFormFieldModule, MatInputModule, AngularSlickgridModule, NbTabsetModule,
       MatDatepickerModule, MatNativeDateModule, NbSelectModule, NbTreeGridModule, 
       SpinnerComponent, MultiSelectModule,
       AgGridAngular
    ],
    providers: [DatePipe],
  })

export class ModelosComponent implements OnInit {

  durationInSeconds = 3;

  eliminarVinSeleccionado = false;
  showSpinnerGrillaAlta = false;
  showSpinnerGuardarVin = false;
  showSpinnerGuardarModelos = false;
  showSpinnerModificarVin = false;
  showSpinnerModificarModelos = false;
  showSpinnerConsulta = false;
  showModelosConsulta = false;
  modelos: SelectItem[];
  showModelos = false
  modeloProcesado;
  modeloProcesadoVinModificar;
  firstForm: FormGroup;
  descripcionModeloEditar;
  descripcionBreveEditar;
  codigoExterno;
  codigoExternoEditar;
  modelosCompleto;
  descripcionVIN;
  name = new FormControl('');
  idCliente: number;
  datasetModelos: any[] = [];
  datasetModelosConsulta: any[] = [];
  angularGridModelos: AngularGridInstance;
  angularGridModelosConsulta: AngularGridInstance;
  columnDefinitionsModelos: ColDef[];//Column[];
  gridOptionsModelos: GridOption;

  columnDefinitionsModelosConsulta: ColDef[];//Column[];
  gridOptionsModelosConsulta: GridOption;
  eliminarSeleccionado;
  codificacionCompleta;
  vin: SelectItem[];
  idVin: number;
  vinOK = false;
  vinProcesado;
  // Cambios Relacion VIN - Proceso
  codigoVin = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17]
  codigoVinSinProcesar = ['', '', '', ' ', '*', '', '*', ' ', ' ', ' ', '', ' ', ' ', ' ', ' ', ' ', ' '];
  cantidadDeVins = [1]
  vinesProcesados = [['', '', '', ' ', '*', '', '*', ' ', ' ', ' ', '', ' ', ' ', ' ', ' ', ' ', ' ']]
  digAdi = [{ d1: 5, d2: 6, d3: 7 }]
  nombreModelo: string = '';

  codificacionSeleccionada: any;
  modeloSeleccionado: any;
  cod: any;
  asignarNuevoModelo: Boolean = false;
  cambioModeloCodificacion: any;
  codificacionesPorModelo: any; // array de codificaciones cuando se ve la pantalla de modificaciones
  codificacionesPorModelosNuevas: any = []; // array de codificaciones nuevas cuando se esta en la pantalla de modificaciones
  habilitarModificarModelos: Boolean = false;
  reasignarModelo = [];

  datosAModificar = {
    modelos: [],
    idCodificaciones: []
  };
  guardarModificarDisabled = true

  @ViewChild('grilla1') grilla1!: AgGridAngular;
  @ViewChild('grilla2') grilla2!: AgGridAngular;
  @ViewChild('grilla3') grilla3!: AgGridAngular;

  constructor(private fb: FormBuilder, private AveriasService: AveriasService,
    private _snackBar: MatSnackBar, private dateFormatter: DatePipe,
    public usersRol: PerfilesUsuarioService, private dialogService: NbDialogService) { }

  ngOnInit(): void {
    this.idCliente = Number(localStorage.getItem('idCliente'));
    this.firstForm = this.fb.group({
      firstCtrl: ['-', Validators.required],
    });
  }

  onChangeTab(event) {
    if (event.tabTitle == "Consulta") {
      // Reemplaza la de consulta
      !this.datasetModelosConsulta.length
        && this.consultarVin('Consulta');
      //
      this.eliminarSeleccionado = false;
      this.eliminarVinSeleccionado = false
      this.codificacionSeleccionada = null
      this.modeloSeleccionado = null
      this.habilitarModificarModelos = false
      this.codificacionesPorModelo = null
    }
    if (event.tabTitle == "Nuevo MODELO-VIN") {
      this.eliminarSeleccionado = false;
      this.eliminarVinSeleccionado = false
      this.codificacionSeleccionada = null
      this.modeloSeleccionado = null
      this.habilitarModificarModelos = false
      this.codificacionesPorModelo = null
    }
    if (event.tabTitle == "Modificación MODELO-VIN") {
      this.consultarVin();
      this.consultarModelosModificar();
      this.eliminarSeleccionado = false;
      this.eliminarVinSeleccionado = false
      this.datosAModificar = {
        idCodificaciones: [],
        modelos: []
      }
      this.codificacionesPorModelosNuevas = []
    }
  }
  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }
  consultarModelos() {
    this.showSpinnerGrillaAlta = true;
    this.showModelos = false;
    this.AveriasService.getModelos(this.idCliente).subscribe(
      data => {
        this.modelosCompleto = data;
        this.modelos = this.insertarModelos(data);
      });
  }
  consultarModelosModificar() {
    this.AveriasService.getModelos(this.idCliente).subscribe(
      data => {
        this.modelosCompleto = data;
        this.modelos = this.insertarModelos(data);
      });
  }
  consultarModelosVin() {
    this.AveriasService.getModelos(this.idCliente).subscribe(
      data => {
        this.modelosCompleto = data;
        this.modelos = this.insertarModelos(data);
      });
  }
  insertarModelos(armarModelos) {
    let averiasModelos: Array<any> = [];
    armarModelos.content.forEach(element => {
      averiasModelos.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return averiasModelos;
  };
  consultarVin(tipo?: String) {
    if (tipo === 'Consulta') {
      // Esto reemplazaria la funcion de consulta
      this.showSpinnerConsulta = true;
      this.showModelosConsulta = false;
      this.AveriasService.getVinModelos(this.idCliente).subscribe(
        data => {
          this.modelosCompleto = data;
          this.traerDatosModelosConsulta();
          this.fillGrillaModelosConsulta();
        });
    } else {
      // Trae las codificaciones
      this.AveriasService.getVinModelos(this.idCliente).subscribe(
        data => {
          this.codificacionCompleta = data;
          this.vin = this.insertarVin(data);
        });
    }
  }
  insertarVin(armarVin) {
    let averiasVIn: Array<any> = [];
    armarVin.forEach((element: any) => {
      let arr = [...this.codigoVinSinProcesar]
      arr.splice(0, 1, element.primeros3Digitos[0])
      arr.splice(1, 1, element.primeros3Digitos[1])
      arr.splice(2, 1, element.primeros3Digitos[2])
      arr.splice(4, 1, element.digito5 === '?' ? 'X' : element.digito5)
      arr.splice(5, 1, element.digito6)
      arr.splice(6, 1, element.digito7 === '?' ? 'X' : element.digito7)
      arr.splice(10, 1, element.digito11)
      averiasVIn.push({
        label: arr.join(''),
        value: element.id,
      });
    })
    return averiasVIn;
  };
  capturarVin(event) {
    this.idVin = event;
    this.vinOK = true;
  }
  altaVin() {
    let modelos: codificacionModelosDTO;

    let checkVines = this.vinesProcesados.map((vin) => {
      let arr = [...vin]
      arr.splice(4, 1) // sacamos el digito 5 que no es obligatorio
      arr.splice(5, 1) // sacamos el digito 6 que no es obligatorio
      return arr.some(v => v === '') // si no existe alguno valor devuelve true
    })
    let completeVines = checkVines.every(e => e === false) // deben ser todos false

    if (this.nombreModelo === '') {
      this.openSnackBar("Debe Completar el Modelo ❌");
    } else if (!completeVines) {
      this.openSnackBar("Debe Completar el VIN ❌");
    }
    else {
      this.descripcionVIN = this.vinesProcesados.map(vin => {
        let arr = [...vin]
        let pos = arr.findIndex(e => e === '')
        if (pos) {
          arr.splice(pos, 1, '?')
          let pos2 = arr.findIndex(e => e === '')
          if (pos2) arr.splice(pos2, 1, '?')
        }
        return arr.join('')
      })
      modelos = {
        codificacion: this.descripcionVIN,
        idModelo: this.nombreModelo,
        eliminado: false,
        idCliente: this.idCliente
      }
      this.showSpinnerGuardarVin = true;

      this.AveriasService.saveModelo(modelos).subscribe(data => {
        if (data["status"] == 201) {
          this.descripcionVIN = '';
          this.openSnackBar('Los cambios se han guardado correctamente');
        } else {
          this.openSnackBar('Ha ocurrido un error al guardarse los datos');
        }
        this.nombreModelo = ''
        this.cantidadDeVins = [1]
        this.vinesProcesados = [['', '', '', ' ', '', '', '', ' ', ' ', ' ', '', ' ', ' ', ' ', ' ', ' ', ' ']]
        this.consultarModelos();
        this.showSpinnerGuardarVin = false;
      }, err => {
        this.openSnackBar(err)
        this.showSpinnerGuardarVin = false;
      }
      )
    }
  }
  modificarVin() {
    let vin: codificacionModelosDTO;
    if (this.eliminarVinSeleccionado) {
      // Borra la codificacion
      this.AveriasService.deleteCodificacion(this.vinProcesado).subscribe(data => {
        if (data["status"] == 204) {
          this.showSpinnerModificarVin = true;
          this.openSnackBar('Los datos se han eliminado correctamente');
          this.vinProcesado = '';
          this.modeloProcesadoVinModificar = '';

        } else {
          this.openSnackBar('Ha ocurrido un error al borrar los datos');
        }
        this.consultarVin();
        this.consultarModelosVin();
        this.eliminarSeleccionado = false;
        this.eliminarVinSeleccionado = false;
        this.showSpinnerModificarVin = false;
      })
    } else {
      if (this.vinProcesado == null || this.vinProcesado == "") {
        this.openSnackBar("Debe Completar el Vin ❌");
      } else if (this.modeloProcesadoVinModificar == null || this.modeloProcesadoVinModificar == "") {
        this.openSnackBar("Debe Completar el Modelo ❌");
      } else {
        this.showSpinnerModificarVin = true;
        vin = {
          codificacion: [],
          // codificacion: this.vin.find(el => el.value == this.vinProcesado).label,
          idModelo: this.modeloProcesadoVinModificar,
          eliminado: false,
          idCliente: this.idCliente
        }
        this.AveriasService.putVin(this.vinProcesado, vin).subscribe(data => {
          if (data["status"] == 200) {
            this.openSnackBar('Los cambios se han guardado correctamente');
          } else {
            this.openSnackBar('Ha ocurrido un error al guardarse los datos');
          }
          this.showSpinnerModificarVin = false;
          this.eliminarVinSeleccionado = false;
          this.consultarVin();
          this.consultarModelosVin();
        })
        this.vinProcesado = '';
        this.modeloProcesadoVinModificar = '';
        this.eliminarVinSeleccionado = false;
      }
    }
  }
  traerDatosModelos() {
    let DatosModelos = this.modelosCompleto['content'];
    let mockDataset: any = [];
    for (let i = 0; i < DatosModelos.length; i++) {
      mockDataset.push({
        id: DatosModelos[i]["id"],
        Descripcion: DatosModelos[i]["descripcion"],
        DescripcionAbreviada: DatosModelos[i]["descripcionAbreviada"],
      });
    }
    this.datasetModelos = mockDataset;
    this.showSpinnerGrillaAlta = false;
    this.showModelos = true;
  }
  traerDatosModelosConsulta() {
    let DatosModelos = this.modelosCompleto;
    let mockDataset: any = [];
    for (let i = 0; i < DatosModelos.length; i++) {
      mockDataset.push({
        id: DatosModelos[i]["id"],
        Descripcion: DatosModelos[i]["descripcion"],
        DescripcionAbreviada: DatosModelos[i].descripcionAbreviada,
        Codificacion: this.armarCodificaciones(DatosModelos[i])
      });
    }
    this.datasetModelosConsulta = mockDataset;
    this.showSpinnerConsulta = false;
    this.showModelosConsulta = true;
  }
  fillGrillaModelos() {
    this.columnDefinitionsModelos = [
      { //id: 'Descripcion', 
        headerName: 'Descripción', field: 'Descripcion', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
      { //id: 'DescripcionAbreviada', 
        headerName: 'Descripción Abreviada', field: 'DescripcionAbreviada', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
    ];
    this.gridOptionsModelos = {
      enableAutoResize: true,
      enableGridMenu: false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: { selectActiveRow: false }
    };
  }
  fillGrillaModelosConsulta() {
    this.columnDefinitionsModelosConsulta = [
      { //id: 'Descripcion', 
        headerName: 'Descripción', field: 'Descripcion', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
      { //id: 'DescripcionAbreviada', 
        headerName: 'Descripción Abreviada', field: 'DescripcionAbreviada', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
      { //id: 'Codificacion', 
        headerName: 'Codificacion', field: 'Codificacion', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
    ];
    this.gridOptionsModelosConsulta = {
      enableExcelExport: true,
      enableAutoResize: true,
      enableGridMenu: false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: { selectActiveRow: false },
      forceFitColumns: true
    };
  }
  angularGridReadyModelosConsulta(angularGrid: AngularGridInstance) //event: any)//
  {
  //   const angularGrid2 = event.detail;
  //   console.dir(Object.keys(angularGrid2));
  // // obtenés la instancia completa
  // const angularGrid = (event as any).detail as AngularGridInstance;

  // // Accedemos directo al resizerService
  // const resizerService = angularGrid.resizerService;
  // if (!resizerService) {
  //   console.warn('resizerService no está disponible');
  //   return;
  // }

  // // Pausamos el redimensionado
  // resizerService.pauseResizer(false);

  // // Guardás la instancia si la necesitás luego
  // this.angularGridModelosConsulta = angularGrid;

     this.angularGridModelosConsulta = angularGrid;
     
     this.angularGridModelosConsulta.resizerService.pauseResizer(false)
  }
  angularGridReadyModelos(angularGrid: AngularGridInstance) {
    this.angularGridModelos = angularGrid;
    this.angularGridModelos.resizerService.pauseResizer(false)
  }
  // exportToExcelModelos() {
  //   (this.angularGridModelosConsulta as any).excelExportService.exportToExcel({
  //     filename: 'Modelos_' + this.dateFormatter.transform(new Date(), "dd-MM-yyyy"),
  //     format: FileType.xlsx
  //   });
  // }

  autoSelectModelo() {
    this.modeloProcesadoVinModificar = this.codificacionCompleta.find(el => el["id"] == this.vinProcesado)["idModelo"];
  }

  // Cambio Asociacion VIN-MODELO
  saveDigito(item: number, rowPos: number, digito: any) {
    this.vinesProcesados[rowPos - 1].splice(item - 1, 1, digito.toUpperCase())
  }

  agregarVin() {
    this.cantidadDeVins.push(this.cantidadDeVins.length + 1)
    let arr = [...this.codigoVinSinProcesar]
    this.vinesProcesados.push(arr)
    let obj = { ...this.digAdi[0] }
    this.digAdi.push(obj)
  }

  // Codificaciones Nuevas en Modificacion
  agregarVinModificacion() {
    let arr = [...this.codigoVinSinProcesar]
    this.codificacionesPorModelosNuevas.push(arr)
    this.guardarModificarDisabled = false
  }

  saveDigitoModificacion(item: number, rowPos: number, digito: any) {
    this.codificacionesPorModelosNuevas[rowPos].splice(item - 1, 1, digito.toUpperCase())
  }

  deleteCodificacionNuevaModificacion(rowPos: number) {
    this.codificacionesPorModelosNuevas.splice(rowPos, 1)
    if (!this.codificacionesPorModelosNuevas.length) {
      this.guardarModificarDisabled = true
    }
  }
  // 

  disabledInputs(item: number, rows: number) {
    let boolean: string;
    // let { d1, d2, d3 } = this.digAdi[rows - 1]
    if (item === 4 || (item >= 8 && item <= 10) || item > 11) {
      boolean = 'true'
    } else {
      boolean = 'false'
    }
    return boolean
  }

  styleInputs(item: number) {
    if ((item >= 1 && item <= 3) || item === 6 || item === 11) {
      return { 'border': '1px solid #007749', 'border-radius' : '5px', 'color' : '#007749' }
    } else if(item === 5 || item === 7) {
      return { 'color': '#4D5656', 'border': '1px solid #4D5656', 'border-radius' : '5px' }
    }
  }
  styleInputsModificar(item: number){
    if ((item >= 1 && item <= 3) || item === 6 || item === 11) {
      return 'inputModeloObligatorios'
    } 
    else if(item === 5 || item === 7) {
      return 'inputModeloOpcionales'
    }
  }

  deleteRow(rows: number) {
    this.cantidadDeVins.splice(rows - 1, 1)
    this.vinesProcesados.splice(rows - 1, 1)
    this.digAdi.splice(rows - 1, 1)
  }

  selectCodificacion() {
    this.modeloSeleccionado = null
    this.cod = this.codificacionCompleta.find(e => e.id === this.codificacionSeleccionada)
    let arr = [...this.codigoVinSinProcesar]
    arr.splice(0, 1, this.cod.primeros3Digitos[0])
    arr.splice(1, 1, this.cod.primeros3Digitos[1])
    arr.splice(2, 1, this.cod.primeros3Digitos[2])
    arr.splice(4, 1, this.cod.digito5 === '?' ? '*' : this.cod.digito5)
    arr.splice(5, 1, this.cod.digito6)
    arr.splice(6, 1, this.cod.digito7 === '?' ? '*' : this.cod.digito7)
    arr.splice(10, 1, this.cod.digito11)
    this.cod.codificacion = arr.join('')
  }

  selectModelo() {
    this.habilitarModificarModelos = false
    let codsModelos = this.codificacionCompleta.filter(e => e.idModelo === this.modeloSeleccionado)
    codsModelos.forEach(element => {
      this.reasignarModelo.push(element.descripcion)
      let arr = [...this.codigoVinSinProcesar]
      arr.splice(0, 1, element.primeros3Digitos[0])
      arr.splice(1, 1, element.primeros3Digitos[1])
      arr.splice(2, 1, element.primeros3Digitos[2])
      arr.splice(4, 1, element.digito5 === '?' ? '*' : element.digito5)
      arr.splice(5, 1, element.digito6)
      arr.splice(6, 1, element.digito7 === '?' ? '*' : element.digito7)
      arr.splice(10, 1, element.digito11)
      element.codificacionArr = arr
      element.codificacion = arr.join('')
    });
    this.codificacionesPorModelo = codsModelos
    this.datosAModificar = {
      idCodificaciones: [],
      modelos: []
    }
    this.codificacionesPorModelosNuevas = []
    this.guardarModificarDisabled = true
  }

  modificarModelos2() {
    this.habilitarModificarModelos = true
  }

  modifyDigito(item: number, rowPos: number, digito: any) {
    this.guardarModificarDisabled = false
    this.codificacionesPorModelo[rowPos].codificacionArr.splice(item - 1, 1, digito.toUpperCase())
    let idGuardado = this.datosAModificar.idCodificaciones.find(e => e === this.codificacionesPorModelo[rowPos].id)
    if (!idGuardado) {
      this.datosAModificar.idCodificaciones.push(this.codificacionesPorModelo[rowPos].id)
    }
  }

  armarCodificaciones(obj: any) {
    let arr = [...this.codigoVinSinProcesar]
    arr.splice(0, 1, obj.primeros3Digitos[0])
    arr.splice(1, 1, obj.primeros3Digitos[1])
    arr.splice(2, 1, obj.primeros3Digitos[2])
    arr.splice(4, 1, obj.digito5 === '?' ? '*' : obj.digito5)
    arr.splice(5, 1, obj.digito6)
    arr.splice(6, 1, obj.digito7 === '?' ? '*' : obj.digito7)
    arr.splice(10, 1, obj.digito11)
    arr.forEach((e, i) => {
      switch (i) {
        case 3: arr.splice(i, 1, '*')
        case 7: arr.splice(i, 1, '*')
        case 8: arr.splice(i, 1, '*')
        case 9: arr.splice(i, 1, '*')
        case 11: arr.splice(i, 1, '*')
        case 12: arr.splice(i, 1, '*')
        case 13: arr.splice(i, 1, '*')
        case 14: arr.splice(i, 1, '*')
        case 15: arr.splice(i, 1, '*')
        case 16: arr.splice(i, 1, '*')
        default:
          break;
      }
    })
    return arr.join('')
  }

  cambioModeloCondificacion(rows: any, i: number) {
    this.guardarModificarDisabled = false
    let modeloNuevo = this.modelos.find(e => e.value === this.reasignarModelo[i])
    rows.idNuevoModelo = modeloNuevo.value
    this.datosAModificar.modelos.push(rows)
  }

  deleteCodificacion(codificacion: any) {
    this.showSpinnerModificarVin = true;
    this.AveriasService.deleteCodificacion(codificacion.id).subscribe(data => {
      if (data["status"] == 204) {
        let codActualizada = this.codificacionesPorModelo.filter(e => e.id !== codificacion.id)
        this.codificacionesPorModelo = codActualizada
        this.openSnackBar('La codificacion se ha eliminado correctamente');
      } else {
        this.openSnackBar('Ha ocurrido un error al borrar los datos');
      }
    })
    this.consultarVin();
    this.showSpinnerModificarVin = false;
  }

  eliminarModelo() {
    this.showSpinnerModificarVin = true;
    this.AveriasService.deleteModelos(this.modeloSeleccionado).subscribe(
      data => {
        if (data["status"] == 204) {
          this.openSnackBar('El modelo se ha eliminado correctamente');
          this.modeloSeleccionado = '';
        } else {
          this.openSnackBar('Ha ocurrido un error al borrar los datos');
        }
        this.consultarVin();
        this.consultarModelosModificar();
        this.showSpinnerModificarVin = false;
      })
  }

  guardarCambios() {
    // Se guardan el modelo y la codficiacion
    let cod: codificacionModelosDTO;
    let modelo: modeloDTO;
    this.showSpinnerModificarVin = true;

    let promises = []

    // Si se modificaron codificaciones entra aca
    if (this.datosAModificar.idCodificaciones.length) {
      for (let i = 0; i < this.datosAModificar.idCodificaciones.length; i++) {
        let idCodificacion = this.datosAModificar.idCodificaciones[i]
        let codificacion = this.codificacionesPorModelo.find(e => e.id === idCodificacion)
        codificacion.codificacionArr[4] = !codificacion.codificacionArr[4].trim().length ? '?' : codificacion.codificacionArr[4]
        codificacion.codificacionArr[6] = !codificacion.codificacionArr[6].trim().length ? '?' : codificacion.codificacionArr[6]
        cod = {
          codificacion: [codificacion.codificacionArr.join('')],
          idModelo: codificacion.descripcion,
          idCliente: this.idCliente,
          eliminado: false
        }
        promises.push(this.AveriasService.putCodificacion(idCodificacion, cod))
      }
    }

    // Si se modificaron modelos entra aca
    if (this.datosAModificar.modelos.length) {
      for (let i = 0; i < this.datosAModificar.modelos.length; i++) {
        let modeloActual = this.datosAModificar.modelos[i]
        let newModelo = this.modelos.find(e => e.value === modeloActual.idNuevoModelo)
        modelo = {
          descripcion: newModelo.label,
          descripcionAbreviada: newModelo.label,
          idCliente: this.idCliente
        }
        promises.push(this.AveriasService.putModeloBycodificacion(modeloActual.id, modelo))
      }
    }

    // Si se agregan nuevas codificaciones entra aca
    if (this.codificacionesPorModelosNuevas.length) {
      let checkVines = this.codificacionesPorModelosNuevas.map((vin) => {
        let arr = [...vin]
        arr.splice(4, 1) // sacamos el digito 5 que no es obligatorio
        arr.splice(5, 1) // sacamos el digito 6 que no es obligatorio
        return arr.some(v => v === '') // si no existe alguno valor devuelve true
      })
      let completeVines = checkVines.every(e => e === false) // deben ser todos false

      if (!completeVines) {
        this.openSnackBar("Debe Completar el VIN ❌");
        this.showSpinnerModificarVin = false;
        return
      }

      // for (let i = 0; i < this.codificacionesPorModelosNuevas.length; i++) {
      //   let prom = this.altaVinModificacion(this.codificacionesPorModelosNuevas[i])
      //   promises.push(prom)
      // }

      let prom = this.altaVinModificacion()
      promises.push(prom)
    }

    forkJoin(promises) // Funciona parecido a un Promise.all()
      .pipe(catchError(error => of({ error: error })))
      .subscribe(data => {
        if (Array.isArray(data)) {
          this.consultarVin() // trae las codificacion actualizadas
          let timer = setInterval(() => {
            // Le puse el timer para que se actualice la pantalla con los nuevos datos 
            this.selectModelo() // actualiza la vista de codififcaciones
            this.consultarModelosModificar();
            this.datosAModificar = {
              idCodificaciones: [],
              modelos: []
            }
            this.codificacionesPorModelosNuevas = []
            this.habilitarModificarModelos = false
            this.guardarModificarDisabled = true
            this.showSpinnerModificarVin = false
            clearInterval(timer)
            this.openSnackBar('Los cambios se han guardado correctamente');
          }, 2000)
        } else {
          this.openSnackBar('Ha ocurrido un error al guardarse los datos')
        }
      })
  }

  // altaVinModificacion(cod) {
  //   let modelos: codificacionModelosDTO;
  //   let modelo = this.codificacionCompleta.filter(e => e.idModelo === this.modeloSeleccionado)

  //   if (cod[4] === '') cod.splice(4, 1, '?')
  //   if (cod[6] === '') cod.splice(6, 1, '?')
  //   let cod2 = cod.join('')

  //   modelos = {
  //     codificacion: [cod2],
  //     idModelo: modelo[0].descripcion,
  //     eliminado: false,
  //     idCliente: this.idCliente
  //   }
  //   return this.AveriasService.saveModelo(modelos)
  // }

  altaVinModificacion() {
    let modelos: codificacionModelosDTO;
    let nombreModelo = this.codificacionCompleta.filter(e => e.idModelo === this.modeloSeleccionado)

    this.descripcionVIN = this.codificacionesPorModelosNuevas.map(vin => {
      let arr = [...vin]
      let pos = arr.findIndex(e => e === '')
      if (pos) {
        arr.splice(pos, 1, '?')
        let pos2 = arr.findIndex(e => e === '')
        if (pos2) arr.splice(pos2, 1, '?')
      }
      return arr.join('')
    })

    modelos = {
      codificacion: this.descripcionVIN,
      idModelo: nombreModelo[0].descripcion,
      eliminado: false,
      idCliente: this.idCliente
    }
    return this.AveriasService.saveModelo(modelos)
  }

  openPopUpConfirmacion(tipo: string, pos?: any) {
    this.dialogService.open(PopupConfirmacionComponent, {
      context: { dialogData: tipo }
    }).onClose.subscribe(res => {
      if (res === 'Si') {
        if (tipo === 'codificacion') {
          this.deleteCodificacion(pos)
        } else {
          this.eliminarModelo()
        }
      }
    });
  }


  exportToExcelModelos(): void {
        const rowData: any[] = [];
       const columnasVisibles = this.grilla1.api.getAllDisplayedColumns();
      
        // Obtener solo las filas visibles (después de filtros y orden)
        this.grilla1.api.forEachNodeAfterFilterAndSort((node) => {
          if (node.data) {
            const filaFiltrada: any = {};
      
            // Solo columnas visibles
            columnasVisibles.forEach(col => {
              const campo = col.getColDef().field;
              if (campo && campo!='action') {
                filaFiltrada[campo] = node.data[campo];
              }
            });
            rowData.push(filaFiltrada);
          }
        });
      
        if (rowData.length === 0) {
          console.warn('No hay datos para exportar');
          return;
        }
      
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowData);
        const workbook: XLSX.WorkBook = {
          Sheets: { 'Modelos': worksheet },
          SheetNames: ['Modelos']
        };
      
        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });
      
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        FileSaver.saveAs(blob, 'Modelos_' + this.dateFormatter.transform(new Date(), 'dd-MM-yyyy') + '.xlsx');
      }

    onGridReady(params: GridReadyEvent): void {
    this.grilla1.api.sizeColumnsToFit();
    this.grilla2.api.sizeColumnsToFit();
    this.grilla3.api.sizeColumnsToFit();
  
  }
  
  
}